import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";

import {
  closeDrawer,
  openDrawer,
  selectItem,
} from "../../store/layoutDashboard/layoutSlice";
import { logout, openModalChangePassword } from "../../store/auth/authSlice";
import { change } from "../../store/language/languageSlice";

export const ToolbarAppbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("global");
  const dispatch = useDispatch();
  const { drawerIsOpen } = useSelector((state) => state.layout);
  const { avatar, role, urlDocuments } = useSelector((state) => state.auth);
  const name = avatar.split("-")[0];
  const surnames = avatar.split("-")[1];
  const initialsWords = name[0] + surnames[0];

  const handleDrawerOpen = () => {
    dispatch(openDrawer());
  };

  const handleDrawerClose = () => {
    dispatch(closeDrawer());
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changePassword = () => {
    handleClose();
    dispatch(openModalChangePassword());
  };

  const finishSession = () => {
    try {
      window.flutter_inappwebview.callHandler("notifications");
      dispatch(logout());
    } catch (error) {
      dispatch(logout());
    }
  };

  const goMyProfile = () => {
    dispatch(selectItem(""));
    navigate("/myprofile");
    handleClose();
  };

  const translate = (language) => {
    i18n.changeLanguage(language);
    dispatch(change());
    handleClose();
  };

  const goCompanies = () => {
    navigate(`/companies`);
  };

  const goMyDocuments = () => {
    window.open(urlDocuments, "_blank");
    handleClose();
  };

  return (
    <>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          {drawerIsOpen ? (
            <IconButton
              onClick={handleDrawerClose}
              size="small"
              edge="start"
              color="primary"
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
          ) : (
            <IconButton
              onClick={handleDrawerOpen}
              size="small"
              edge="start"
              color="primary"
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          )}
        </Box>
        <Button
          onClick={handleClick}
          size="small"
          edge="end"
          color="primary"
          sx={{ gap: 1 }}
        >
          <Avatar {...stringAvatar(initialsWords)} />
          <KeyboardArrowDownIcon />
        </Button>
        <Menu
          elevation={10}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{ zIndex: 9999 }}
        >
          <MenuItem onClick={goMyProfile} sx={{ gap: 2, color: "#001B60" }}>
            <AccountCircleSharpIcon color="primary" />
            {t("navbarLayout.profile")}
          </MenuItem>
          {role !== "Admin" && (
            <MenuItem onClick={goCompanies} sx={{ gap: 2, color: "#001B60" }}>
              <PeopleAltSharpIcon color="primary" />
              {t("drawer.companies")}
            </MenuItem>
          )}
          {urlDocuments && role !== "Admin" && (
            <MenuItem onClick={goMyDocuments} sx={{ gap: 2, color: "#001B60" }}>
              <AssignmentIndIcon color="primary" />
              {t("drawer.documents")}
            </MenuItem>
          )}
          <MenuItem onClick={changePassword} sx={{ gap: 2, color: "#001B60" }}>
            <PasswordOutlinedIcon color="primary" />
            {t("navbarLayout.changePassword")}
          </MenuItem>
          <MenuItem
            onClick={() => translate("es")}
            sx={{ gap: 2, color: "#001B60" }}
          >
            <img src="/es.png" width="27" alt="Bandera España" />
            Español
          </MenuItem>
          <MenuItem
            onClick={() => translate("en")}
            sx={{ gap: 2, color: "#001B60" }}
          >
            <img src="/gb.png" width="28" alt="Bandera Reino Unido" />
            English
          </MenuItem>
          <Divider />
          <MenuItem onClick={finishSession} sx={{ gap: 2, color: "#001B60" }}>
            <ExitToAppOutlinedIcon color="primary" />
            {t("navbarLayout.exit")}
          </MenuItem>
        </Menu>
      </Toolbar>
      <div style={{ backgroundColor: "#F5F5F5", height: "15px" }}></div>
    </>
  );
};

function stringAvatar(userName) {
  return {
    sx: {
      bgcolor: "#EA7F22",
      width: "32px",
      height: "32px",
      fontSize: "15px",
    },
    children: userName,
  };
}
